import { getTheme } from '../queries/theme';
import { useGenericQuery } from '../../../core/api/reactQuery';

const noop = () => {};

export function useEssayTheme(slug: string) {
  const { 
    data, 
    isError, 
    error, 
    isSuccess, 
    isPending 
  } = useGenericQuery(['theme', slug], () => getTheme(slug), noop);

  return {
    data,
    isError,
    isPending,
    error,
    isSuccess,
  }
}
